const DEFAULT_LAYOUT = () => import('@/layout/main-layout.vue');

const APPROVECENTER = {
  path: '/approve',
  name: 'approve',
  component: DEFAULT_LAYOUT,
  redirect: { name: 'approve-center' },
  meta: {
    title: '审批中心',
    requiresAuth: true,
    hideChildrenInMenu: true,
    icon: 'qf-icon-approve',
    roles: 'approvalCenter',
    order: 10
  },
  children: [
    {
      path: '',
      name: 'approve-center',
      component: () => import('@/views/approve-center/index.vue'),
      meta: {
        requiresAuth: true,
        title: '审批中心',
        roles: 'approvalCenter:approvalCenter'
      }
    }
  ]
};

export default APPROVECENTER;
